import type { CategoriesViewProps } from '../../types';
import * as React from 'react';
import { DefaultView as ViewComponent } from '../../components/DefaultView';

export function View(props: CategoriesViewProps) {
  return (
    <>
      <ViewComponent {...props} />
    </>
  );
}
